import React from 'react';

export const Slide2 = () => (
    <svg viewBox='0 0 281 176' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_50_2971)'>
            <rect width='53' height='24' rx='3' fill='white' />
            <rect y='28' width='53' height='148' rx='3' fill='white' />
            <rect x='4' y='76' width='45' height='96' rx='3' fill='#D6F2DE' />
            <rect x='4.5' y='32.5' width='44' height='39' rx='2.5' fill='white' />
            <rect
                x='4.5'
                y='32.5'
                width='44'
                height='39'
                rx='2.5'
                fill='#FF2E47'
                fillOpacity='0.1'
            />
            <rect x='4.5' y='32.5' width='44' height='39' rx='2.5' stroke='#FF2E47' />
        </g>
        <g clipPath='url(#clip1_50_2971)'>
            <rect x='57' width='53' height='24' rx='3' fill='white' />
            <rect x='57' y='28' width='53' height='148' rx='3' fill='white' />
            <rect x='61' y='32' width='45' height='80' rx='3' fill='#D6F2DE' />
            <rect x='61.5' y='116.5' width='44' height='55' rx='2.5' fill='white' />
            <rect
                x='61.5'
                y='116.5'
                width='44'
                height='55'
                rx='2.5'
                fill='#FF2E47'
                fillOpacity='0.1'
            />
            <rect x='61.5' y='116.5' width='44' height='55' rx='2.5' stroke='#FF2E47' />
        </g>
        <g clipPath='url(#clip2_50_2971)'>
            <rect x='114' width='53' height='24' rx='3' fill='white' />
            <rect x='114' y='28' width='53' height='148' rx='3' fill='white' />
            <rect x='118' y='32' width='45' height='80' rx='3' fill='#D6F2DE' />
            <rect x='118.5' y='116.5' width='44' height='55' rx='2.5' fill='white' />
            <rect
                x='118.5'
                y='116.5'
                width='44'
                height='55'
                rx='2.5'
                fill='#FF2E47'
                fillOpacity='0.1'
            />
            <rect x='118.5' y='116.5' width='44' height='55' rx='2.5' stroke='#FF2E47' />
        </g>
        <g clipPath='url(#clip3_50_2971)'>
            <rect x='171' width='53' height='24' rx='3' fill='white' />
            <rect x='171' y='28' width='53' height='148' rx='3' fill='white' />
            <rect x='175' y='76' width='45' height='96' rx='3' fill='#D6F2DE' />
            <rect x='175.5' y='32.5' width='44' height='39' rx='2.5' fill='white' />
            <rect
                x='175.5'
                y='32.5'
                width='44'
                height='39'
                rx='2.5'
                fill='#FF2E47'
                fillOpacity='0.1'
            />
            <rect x='175.5' y='32.5' width='44' height='39' rx='2.5' stroke='#FF2E47' />
        </g>
        <g clipPath='url(#clip4_50_2971)'>
            <rect x='228' width='53' height='24' rx='3' fill='white' />
            <rect x='228' y='28' width='53' height='148' rx='3' fill='white' />
            <rect x='232.5' y='32.5' width='44' height='139' rx='2.5' fill='white' />
            <rect
                x='232.5'
                y='32.5'
                width='44'
                height='139'
                rx='2.5'
                fill='#FF2E47'
                fillOpacity='0.1'
            />
            <rect x='232.5' y='32.5' width='44' height='139' rx='2.5' stroke='#FF2E47' />
        </g>
        <defs>
            <clipPath id='clip0_50_2971'>
                <rect width='53' height='176' fill='white' />
            </clipPath>
            <clipPath id='clip1_50_2971'>
                <rect width='53' height='176' fill='white' transform='translate(57)' />
            </clipPath>
            <clipPath id='clip2_50_2971'>
                <rect width='53' height='176' fill='white' transform='translate(114)' />
            </clipPath>
            <clipPath id='clip3_50_2971'>
                <rect width='53' height='176' fill='white' transform='translate(171)' />
            </clipPath>
            <clipPath id='clip4_50_2971'>
                <rect width='53' height='176' fill='white' transform='translate(228)' />
            </clipPath>
        </defs>
    </svg>
);
